import type { SerializedStyles } from "@emotion/serialize";
import { useTranslation } from "react-i18next";

import { Button, Tooltip } from "@aviary/components";
import { useFlippers } from "@shared/context/FlippersContext";
import { l } from "@shared/locales/i18n";

import { OrSection } from "../OrSection/OrSection";

import * as styles from "./MagicLinkButton.styles";
interface MagicLinkButtonProps {
  storeId?: string;
  disabled?: boolean;
  isOrTextRendered?: boolean;
  buttonStyles?: SerializedStyles;
  isUnauthenticated?: boolean;
}

const MagicLinkButton = ({
  storeId,
  disabled,
  isOrTextRendered,
  buttonStyles,
  isUnauthenticated,
}: MagicLinkButtonProps) => {
  const [isIAMEmailKillswitchEnabled] = useFlippers("iam_killswitch_disable_email_mfa_challenge");
  const { t } = useTranslation();
  const linkURL = storeId
    ? `/continue-without-password?store_id=${storeId}`
    : "/continue-without-password";

  const renderEmailButton = () => {
    if (isIAMEmailKillswitchEnabled) {
      return (
        <Tooltip tooltipContent={t(l.auth.continueWithoutPasswordDisabled)}>
          <Button
            data-e2e="magic-link-flow"
            css={[styles.magicLinkButton, buttonStyles]}
            disabled
            to={linkURL}
          >
            {t(l.magicLink.ContinueWithoutPassword)}
          </Button>
        </Tooltip>
      );
    }

    if (isUnauthenticated) {
      return (
        <Button
          data-e2e="magic-link-flow"
          css={[styles.magicLinkButton, buttonStyles]}
          disabled={disabled}
          href={linkURL}
        >
          {t(l.magicLink.ContinueWithoutPassword)}
        </Button>
      );
    }

    return (
      <Button
        data-e2e="magic-link-flow"
        css={[styles.magicLinkButton, buttonStyles]}
        disabled={disabled}
        to={linkURL}
      >
        {t(l.magicLink.ContinueWithoutPassword)}
      </Button>
    );
  };

  return (
    <div css={styles.buttonWrapper}>
      {renderEmailButton()}
      {!!isOrTextRendered && <OrSection />}
    </div>
  );
};

export { MagicLinkButton };
